export const ApiUrl = `${process.env.REACT_APP_API}/api`;

export const scheduleSeatsUrl = `${ApiUrl}/scheduleSeats`

export const scheduleById = `${ApiUrl}/schedules`